import React from "react";
import logo from "../assets/logo.png";
import { useSettings } from "../context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();

  return (
    <footer className="transition-colors duration-300 bg-slate-100 text-slate-800 dark:bg-slate-900 dark:text-slate-200 py-6">
      <div className="mx-auto max-w-6xl flex flex-col md:flex-row justify-between items-center gap-6 px-4">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <img src={logo} alt={settings.company_name} className="h-10 w-10" />
          <span className="font-bold text-lg">{settings.company_name}</span>
        </div>

        {/* Contact */}
        <div className="flex flex-col items-center md:items-start">
          <p className="text-sm text-slate-600 dark:text-slate-400">
            {settings.company_email}
          </p>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            {settings.company_phone}
          </p>
          <p className="mt-2 text-xs text-slate-500 dark:text-slate-500">
            © {new Date().getFullYear()} {settings.company_name}. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
